module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-3.a63334b7.png";